import { render, staticRenderFns } from "./falabella.vue?vue&type=template&id=c1dfd0a4&scoped=true"
import script from "./falabella.vue?vue&type=script&lang=js"
export * from "./falabella.vue?vue&type=script&lang=js"
import style0 from "./falabella.vue?vue&type=style&index=0&id=c1dfd0a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dfd0a4",
  null
  
)

export default component.exports